import { Avatar } from "V2.0/common/avatar";

function UserProfile(props) {
  const { firstName, lastName, email } = props;
  const initials = [firstName.split(" ")[0], lastName.split(" ")[0]]
    .map((name) => name.charAt(0).toUpperCase())
    .join("");

  return (
    <div className="flex items-center gap-4">
      <Avatar
        className="size-10 bg-zinc-900 text-white dark:bg-white dark:text-black"
        initials={initials}
      />
      <div>
        <p className="font-medium text-zinc-900 dark:text-white">{firstName}</p>
        <p className="text-zinc-500">
          <span className="hover:text-zinc-700">{email}</span>
        </p>
      </div>
    </div>
  );
}

export default UserProfile;
